import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const toiletTrainingNight: BlogMetaData = {
  title: '夜のトイトレ・おねしょ対策｜いつから？進め方と相談目安',
  description:
    '夜のトイトレ・おねしょ対策はいつから？日中との違い、始める目安、進め方、医療機関への相談目安を解説。おねしょは主に体の発達に左右されるため、叱らず焦らないことが大切です。',
  thumbnailUrl: '/img/blog-toilet-training-night.webp',
  filePath: buildBlogFilePath('toilet-training-night'),
  category: BLOG_CATEGORY.PARENTING,
};
